import AppHeader from '../../../components/AppHeader';
import InputSearch from '../../../components/InputSearch';
import Loader from '../../../components/Loader';
import NoData from '../../../components/NoData';
import OpacityAnimation from '../../../components/OpacityAnimation';
import Sidebar from '../../../components/Sidebar';
import Transitions from '../../../components/Transition';
import DeleteModal from './components/DeleteModal';
import List from './components/List';
import ListHeader from './components/ListHeader';
import useLines from './useLines';

export default function Lines() {
  const {
    isLoading,
    companyCode,
    lines,
    apiFetched,
    searchTerm,
    handleChangeSearchTerm,
    filteredLines,
    directionsTagLiterals,
    setLineMapBeingShow,
    setLineBeingPostedShape,
    handleTryAgain,
    isDeleting,
    modalDeleteShow,
    setModalDeleteShow,
    lineBeingDeleted,
    setLineBeingDeleted,
    directionTagLiterals,
    deleteLine,
  } = useLines();

  const isCompanySelected = !!companyCode;
  const doesListExists = lines && !isLoading && apiFetched;
  const hasLinhas = lines && filteredLines?.length !== 0 && apiFetched;
  const isSearchEmpty = filteredLines?.length === 0 && apiFetched && !isLoading;
  const doesntHaveLinhas = !lines && apiFetched && !isLoading;

  return (
    <>
      <AppHeader isCompanySelectedDisabled={false} />
      <Sidebar active="Lines" />
      <Transitions>
        <Loader isLoading={isLoading || isDeleting} />

        {isCompanySelected && (
          <>
            {doesListExists && (
              <OpacityAnimation delay={0.1}>
                <InputSearch
                  searchTerm={searchTerm}
                  handleChangeSearchTerm={handleChangeSearchTerm}
                  placeholder="Pesquisar linha (codigo, letreiro, ou local de trabalho)"
                />
              </OpacityAnimation>
            )}

            {!isLoading && (
              <OpacityAnimation delay={0.05}>
                <ListHeader
                  entity={lines}
                  apiFetched={apiFetched}
                  filteredEntity={filteredLines}
                  linkPath="/lines/new"
                  entityString={{ singular: 'linha', plural: 'linhas' }}
                />
              </OpacityAnimation>
            )}

            {hasLinhas && (
              <List
                filteredLines={filteredLines}
                directionsTagLiterals={directionsTagLiterals}
                setLineMapBeingShow={setLineMapBeingShow}
                setLineBeingPostedShape={setLineBeingPostedShape}
                setLineBeingDeleted={setLineBeingDeleted}
                setModalDeleteShow={setModalDeleteShow}
              />
            )}

            <DeleteModal
              lineBeingDeleted={lineBeingDeleted}
              setDeleteModalShow={setModalDeleteShow}
              deleteLine={deleteLine}
              deleteModalShow={modalDeleteShow}
              directionTagLiterals={directionTagLiterals}
            />

            {isSearchEmpty && (
              <NoData
                icon="searchNotFound"
                label={(
                  <>
                  Nenhum resultado foi encontrado para
                    {' '}
                    <strong>{searchTerm}</strong>
                  </>
                )}
              />
            )}

            {doesntHaveLinhas && (
              <NoData
                icon="emptyBox"
                label={(
                  <>
                  Esta empresa não tem nenhuma linha cadastrada, clique no botão
                    {' '}
                    <strong>Nova Linha</strong>
                    {' '}
                  acima para cadastrar sua primeira!
                  </>
                )}
              />
            )}

            {!apiFetched && (
              <NoData
                icon="sad"
                label={(
                  <>
                  Ocorreu um erro ao obter as linhas.
                    <button type="button" onClick={handleTryAgain}>Tentar Novamente</button>
                  </>
                )}
              />
            )}
          </>
        )}

        {!isCompanySelected && (
          <NoData
            icon="companyInterrogation"
            label={(
              <>
                Selecione uma empresa para visualizar as linhas.
              </>
            )}
          />
        )}

      </Transitions>
    </>
  );
}
